import React, { useMemo } from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import Decimal from 'decimal.js'

import { Module } from '@/modules/moduleSubscription/types/module'
import { ModuleIconMap } from '@/modules/moduleSubscription/components/list/module-item/module-item'
import SvgIcon from '@/modules/base/components/svg-icon/svg-icon'
import lang from '@/lang'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import InfoIcon from '@assets/images/icons/info-icon.svg'
import { useMediaQuery } from '@mui/material'
import { dateConstants } from '@/modules/base/util/constants'

const { YEAR } = dateConstants

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: theme?.white,
    padding: 20,
    borderRadius: 4,
    gap: 24,
    [theme.devices.mobile]: {
      gap: 16,
    },
  },
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  priceWrapper: {
    fontWeight: theme.fontWeights.medium,
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
    fontSize: theme.fontSizes.medium,
  },
  price: {
    fontSize: theme.fontSizes.huge,
  },
}))

interface IModuleItemListItem {
  module: Module
  selectedPeriod: string
}

const ModuleItemListItem = (props: IModuleItemListItem) => {
  const classes = useStyles()
  const { module, selectedPeriod } = props
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.devices.mobile)

  const icon = useMemo(() => {
    return <SvgIcon svg={ModuleIconMap[module.name]} height={32} width={32} />
  }, [module])

  const toolTipContent = useMemo(() => (
    <div>
      {lang.moduleSubscription.list.moduleItem.modules[module.name] || lang.moduleSubscription.list.moduleItem.modules.default}
    </div>
  ), [module])
  const price = useMemo(() => {
    const price = module.prices.find(price => price.period === selectedPeriod)?.values[0]
    return new Decimal(selectedPeriod === YEAR
      ? new Decimal(price.pricePerDuration).dividedBy(12).toDP(2).toNumber()
      : price.pricePerDuration).toDP(2).toNumber()
  }, [module, selectedPeriod])

  return (
    <div className={classes.root}>
      <div className={classes.contentWrapper}>
        {icon}
        <div className={classes.titleWrapper}>
          <div>{module.title}</div>
          {!isMobile && (
            <RichTooltip content={toolTipContent} width={560}>
              <SvgIcon svg={InfoIcon} height='16px' width='16px' />
            </RichTooltip>
          )}
        </div>
      </div>
      <div className={classes.priceWrapper}>
        <div>{lang.moduleSubscription.list.moduleItem.pricePrefix}</div>
        <div className={classes.price}>{lang.moduleSubscription.list.moduleItem.price(price)}</div>
      </div>
    </div>
  )
}

export default ModuleItemListItem
